import { render, staticRenderFns } from "./emergencydnill.vue?vue&type=template&id=39d6b6b1&scoped=true&"
import script from "./emergencydnill.vue?vue&type=script&lang=js&"
export * from "./emergencydnill.vue?vue&type=script&lang=js&"
import style0 from "./emergencydnill.vue?vue&type=style&index=0&id=39d6b6b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6b6b1",
  null
  
)

export default component.exports